import ContainedButton from "Components/HomeV2/Buttons/Contained";

export default function BrandsSection() {
  return (
    <section className="w-full flex  px-q lg:px-0 justify-center flex-col md:flex-row items-center  bg-black text-white py-12">
      {/* Left Content */}
      <div className="w-[50%] flex flex-col  items-center lg:items-start">
        <h2 className="lg:text-[3rem] w-full text-[1rem]  text-center  lg:w-[42%] font-semibold lg:text-left lg:leading-[3.5rem] mb-3 lg:mb-10">
          Connect With 500+ Video Leading Brands
        </h2>
        <a href="https://salesmrkt.com/">
          <ContainedButton size="lg" className="px-10" theme="primary">
            <span className="flex lg:px-10 items-center gap-2 text-white">
              Learn more
            </span>
          </ContainedButton>
        </a>
      </div>

      <img
        src="/brands.png"
        alt="Brands"
        className="lg:h-[400px]  mt-5 lg:mt-0  object-contain"
      />
    </section>
  );
}
